import axios from 'axios'

const endPoint = '/slots'

export function getTracks({ commit, store }, userID) {

    return new Promise((resolve, reject) => {
        axios
            .get(endPoint + "/" + userID)
            .then(response => {
                commit('setCoachingTracks', response.data.data)
                resolve(true)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function resetStore({ commit, store }) {
    commit('resetStore')
}

// {{APIURL}}/api/v1/events/slots/getupcomingevent